<template>
<van-popup
    v-model:show="show"
    :style="{
      maxwWidth: '100vw',
      maxHeight: '100vh',
      display: 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      background: '#f0f3f5'
    }"
  >
    <div class="cropper-container" >
      <div class="img-box" v-show="showImage">
        <img ref="imageEl" class="cropper-image" alt="404" />
      </div>
      <div class="control-container" >
        <!-- <div ref="previewEl" class="preview-box"></div> -->
        <van-button class="reset-button"  @click="onCancel">重置</van-button>
        <van-button class="reset-button"  @click="onOk">确定</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { defineComponent, ref, watch } from 'vue'
import { Button, Popup, Toast } from "vant";
import Cropper from 'cropperjs'
import 'cropperjs/dist/cropper.min.css'
import { compress } from "@/utils/beforUploadFn.js"

export default defineComponent({
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
  },
  emits: ['update:visible', 'submit'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    moveStep: {
      type: Number,
      default: 4
    },
    file: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, { emit }) {
    const imageEl = ref()
    // const previewEl = ref()
    const instance = ref()
    const show = ref(false)
    const showImage = ref(false)

    watch(
      () => props.visible,
      newVal => {
        show.value = props.visible
        if (newVal) {
          const toast = Toast.loading({
            message: '加载中...',
            forbidClick: false,
          });
          setTimeout(() => {
            if (imageEl.value && props.file) {
              console.log(111,  props.file);
              instance.value = new Cropper(imageEl.value, {
                // preview: previewEl.value,
                viewMode: 2,
                checkCrossOrigin: false,
                background: false,
                dragMode: "move",
                aspectRatio: 1,
                minCropBoxWidth: "100",
                minContainerWidth: "100",
                minContainerHeight: "100",
              })
                instance.value?.replace(props.file.content)
                document.getElementsByClassName("cropper-container")[0].style.height = "100vh"
                console.log(document.getElementsByClassName("cropper-hide"));
                if (imageEl.value) showImage.value = true;
                toast.clear();
            }
          }, 20)
        } else {
          instance.value?.destroy()
        }
      }
    )

    function onCancel() {
      emit('update:visible', false)
    }

    const onOk = () => {
      const toast = Toast.loading({
        message: '加载中...',
        forbidClick: false,
      });
      const baseData = instance.value?.getCroppedCanvas().toDataURL();
      compress(baseData, props.file).then(res => {
          res.content = baseData;
          console.log("压缩后", res);
          // this.$store.dispatch("uploadImg", res);
          toast.clear();
          emit('submit', res)
          emit('update:visible', false)
        })
    }


    return {
      imageEl,
      // previewEl,
      show,
      onCancel,
      onOk,
      showImage,
    }
  }
})
</script>

<style lang="scss" scoped>
.img-box {
  display: inline-block;
  // height: 100vh;
  width: 430px;
  border: 1px solid #ebebeb;
  // .bg;
  img {
    max-width: 100%;
    display: block;
  }
}

.control-container {
  width: 100%;
  position: absolute;
  bottom: 0;
  .reset-button {
    width: 50%;
  }
}

.preview-box {
  height: 150px !important;
  width: 150px !important;
  overflow: hidden;
  border: 1px solid #ebebeb;
}

.control {
  margin-top: 15px;
}

.control ::v-deep(.ant-btn) {
  margin-right: 8px;
  margin-bottom: 15px;
}

</style>
